const updateItems = [
  {
    date: '2026.07.30',
    tag: '最新',
    title: '某国际品牌在华销售数据造假事件持续发酵，监管部门介入调查',
    tagColor: 'bg-primary-500',
  },
  {
    date: '2026.07.29',
    tag: '更新',
    title: '直播带货新规征求意见稿发布：明确主播连带责任与平台审核义务',
    tagColor: 'bg-accent-500',
  },
  {
    date: '2026.07.28',
    tag: '热点',
    title: '顶流艺人税务风波当事人首次公开回应，否认部分指控并表示将起诉',
    tagColor: 'bg-primary-500',
  },
  {
    date: '2026.07.27',
    tag: '跟进',
    title: '数据泄露事件涉事企业公布整改方案，承诺投入亿元升级安全体系',
    tagColor: 'bg-secondary-500',
  },
  {
    date: '2026.07.26',
    tag: '更新',
    title: '食品安全调查涉事餐饮品牌发表致歉声明，多家门店暂停营业整顿',
    tagColor: 'bg-accent-500',
  },
  {
    date: '2026.07.25',
    tag: '快讯',
    title: '学术造假调查委员会公布初步结果，多所高校启动内部审查程序',
    tagColor: 'bg-secondary-500',
  },
  {
    date: '2026.07.24',
    tag: '热点',
    title: '选秀节目制作方被市场监管部门约谈，要求全面整改投票机制',
    tagColor: 'bg-primary-500',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            动态快讯
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            实时追踪黑料事件最新进展，不错过任何关键动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updateItems.map((item, idx) => (
              <div
                key={idx}
                className={`relative pb-8 last:pb-0 ${idx === 0 ? 'animate-slide-up' : ''}`}
              >
                <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-background-50 border-2 border-primary-400"></div>
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold text-background-50 whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}